var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlien(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 0C100.25 0 0 87.995 0 232.486C0 344.229 134.25 456.972 194.875 502.344C212.125 515.219 235.875 515.219 253.125 502.344C313.75 456.972 448 344.229 448 232.486C448 87.995 347.75 0 224 0ZM176 319.98H144C99.875 319.98 64 284.108 64 239.985C64 231.111 71.125 223.986 80 223.986H112C156.125 223.986 192 259.859 192 303.981C192 312.856 184.875 319.98 176 319.98ZM304 319.98H272C263.125 319.98 256 312.856 256 303.981C256 259.859 291.875 223.986 336 223.986H368C376.875 223.986 384 231.111 384 239.985C384 284.108 348.125 319.98 304 319.98Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlien);
export default __webpack_public_path__ + "static/media/alien.b2a1b04d90033031178b859ed0583ac5.svg";
export { ForwardRef as ReactComponent };